import { Injectable } from '@angular/core';
import { TimezonesService } from '../services/timezones.service';
import { StatusesService } from '../services/statuses.service';
import { LocalesService } from '../services/locales.service';
import { RegistrationsService } from '../services/registrations.service';
import { DeeplinksService } from '../services/deeplinks.service';
import { SupportingDataService } from 'src/app/shared/services/supporting-data.service';

@Injectable({ providedIn: 'root' })
export class RegistrationDetailsFacade {
  constructor(
    private timezonesService: TimezonesService,
    private statusesService: StatusesService,
    private localesService: LocalesService,
    private registrationsService: RegistrationsService,
    private deeplinksInternalService: DeeplinksService,
    private supportingDataService: SupportingDataService,
  ) {}

  initializeLookups(): void {
    this.timezonesService.fetchTimezones();
    this.statusesService.fetchStatuses();
    this.statusesService.fetchLOAStatuses();
    this.localesService.fetchLocales();
    this.registrationsService.fetchRegistrationTypes();
    this.deeplinksInternalService.setMarketAdminUrl();
    this.deeplinksInternalService.setAssetAdminUrl();
    this.deeplinksInternalService.setCustomersAdminUrl();
    this.deeplinksInternalService.setPortfolioAdminUrl();
    this.deeplinksInternalService.setBaselineAdminUrl();
    this.deeplinksInternalService.setUtilityAccountAdminUrl();
    this.deeplinksInternalService.setEcrmUrl();
    this.supportingDataService.fetchChannelWhitelists();
  }
}
